module.exports = __webpack_public_path__ + "img/banner-direction-ylqx.02b64f92.jpg";